import {useLocation} from "react-router-dom";
import DiscoverLanding from "./discover-landing";
import AchievementsView from "./achievements";
import AchievementGroupDetailView from "./achievements/group-detail";
import {getAchievementThemeFromPath} from "./achievements/helpers";
import LifeJourney from "./life-journey";
import BirdingPersonalityView from "./birding-personality";
import UpcomingTargetsView from "./upcoming-targets";
import type {DiscoverProps} from "./types";
import {usePageTitle} from "../../helpers/usePageTitle";
import './discover.scss';

export default function Discover(props: DiscoverProps) {
    const location = useLocation();
    const isLifeJourney = location.pathname === '/discover/life-journey';
    const isBirdingPersonality = location.pathname === '/discover/birding-personality';
    const isUpcomingTargets = location.pathname === '/discover/upcoming-targets';
    const isAchievements = getAchievementThemeFromPath(location.pathname) !== undefined;
    const isAchievementDetail = !isAchievements && location.pathname.startsWith('/discover/achievements/');

    usePageTitle(
        isLifeJourney ? 'Life Journey' : isBirdingPersonality ? 'Birding Personality' : isUpcomingTargets ? 'Upcoming Targets' : isAchievements || isAchievementDetail ? 'Achievements' : 'Discover',
        isLifeJourney || isBirdingPersonality || isUpcomingTargets || isAchievements || isAchievementDetail ? 'Discover' : undefined
    );

    if (isLifeJourney) {
        return <LifeJourney {...props} />;
    }

    if (isBirdingPersonality) {
        return <BirdingPersonalityView {...props} />;
    }

    if (isUpcomingTargets) {
        return <UpcomingTargetsView {...props} />;
    }

    if (isAchievements) {
        return <AchievementsView {...props} />;
    }

    if (isAchievementDetail) {
        return <AchievementGroupDetailView {...props} />;
    }

    return <DiscoverLanding {...props} />;
}
